import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { useNavigationHooks } from "..";
import { useViewActions } from "../../store";
import { INotification, UrlQueryParams } from "../../store/types";
import { JSON_to_URLEncoded } from "../../utils/json-to-url-encoded";
import { NotificationHandlerType } from "./use-click-handler";

export function useQuestionHook(): NotificationHandlerType {
  const { scrollToAnswerAction } = useViewActions();
  const { getFormPathName } = useNavigationHooks();
  const { push } = useHistory();

  return useCallback(async ({ components }: INotification) => {
    const searchObj: UrlQueryParams = {
      section: components.section_id,
      answer: components.question_uuid //TODO - refactor this, after migration to question primary key for notifications
    };
    if (components.form_id) {
      push({
        pathname: getFormPathName(components.deal_id, components.form_id),
        search: JSON_to_URLEncoded(searchObj)
      });
      scrollToAnswerAction("on");
    }
  }, []);
}
